module.exports = __webpack_public_path__ + "img/ico14.b3e20c56.svg";